/**
 * Abstract assembly block class.
 */
export abstract class AbstractBlock{
    id: string;

    constructor(id: string){
        this.id = id;
    }


    /**
     * Function to evaluate the contents (including children) of this abstract block
     * @param varEnv Variable Environment
     */
    abstract evalBlock(varEnv: Map<string, any>): any;
}